// Placeholder named tutors. Swap names/scores/photo URLs when you have real data.
// `image` is a deterministic avatar from ui-avatars.com so we don't need photo files.
export const tutors = [
  {
    id: 'sarah',
    name: 'Sarah',
    score: 'UCAT 2950',
    bio: 'QR specialist · LSE-trained · 2950 in real UCAT',
    specialty: 'QR',
    section: 'qr',
    weakAreas: ['mental-arithmetic', 'conversion', 'conversion-gauntlet', 'numpad', 'numpad-trainer', 'qr'],
    nextSlot: 'Tomorrow 6pm',
    image: 'https://ui-avatars.com/api/?name=Sarah&background=653192&color=fff&size=128'
  },
  {
    id: 'james',
    name: 'James',
    score: 'UCAT 3010',
    bio: 'Imperial · 5th-year medic · 3010 in real UCAT',
    specialty: 'DM + VR',
    section: 'dm',
    weakAreas: ['venn', 'venn-architect', 'probability', 'probability-reasoning', 'data-probability', 'syllogisms', 'inference', 'inference-builder', 'shape-equations', 'reading-lab', 'dm', 'vr'],
    nextSlot: 'Thursday 4pm',
    image: 'https://ui-avatars.com/api/?name=James&background=3ab8a6&color=fff&size=128'
  },
  {
    id: 'aisha',
    name: 'Aisha',
    score: 'UCAT 2980',
    bio: 'KCL · interview & SJT specialist',
    specialty: 'SJT + Interview',
    section: 'sjt',
    weakAreas: ['sjt-profiler', 'sjt'],
    nextSlot: 'Today 8pm',
    image: 'https://ui-avatars.com/api/?name=Aisha&background=b45309&color=fff&size=128'
  },
  {
    id: 'marcus',
    name: 'Marcus',
    score: 'GAMSAT 78',
    bio: 'Cambridge GEM · GAMSAT 78 overall · Section 3 specialist',
    specialty: 'GAMSAT',
    section: 'gamsat',
    weakAreas: ['gamsat-essay', 'gamsat'],
    nextSlot: 'Saturday 11am',
    image: 'https://ui-avatars.com/api/?name=Marcus&background=23143f&color=fff&size=128'
  }
];

// Pick best tutor by drill slug or section. Falls back to first tutor.
export function tutorFor(slug) {
  if (!slug) return tutors[0];
  const match = tutors.find((t) => t.weakAreas.includes(slug));
  return match || tutors[0];
}
